import styled from 'styled-components';

export const Box = styled.footer`
  width: 100%;
  background: #f8f9fb;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  color: #101828;
  padding: 28px 0 24px;

  &.dark-theme {
    background: #0d1117;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    color: #e8ecf2;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  text-align: center;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const BrandMark = styled.div`
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: inherit;
`;

export const Tagline = styled.div`
  font-size: 14px;
  opacity: 0.85;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(240px, 320px));
  column-gap: 64px;
  row-gap: 18px;
  align-items: start;
  justify-content: center;
  justify-items: center;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    column-gap: 24px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

export const Heading = styled.p`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0 0 2px;
  color: inherit;
  opacity: 0.9;
  text-align: center;
`;

export const FooterLink = styled.a`
  color: inherit;
  font-size: 14px;
  text-decoration: none;
  opacity: 0.92;
  transition: color 160ms ease, opacity 160ms ease;

  &:hover {
    color: #4c6fff;
    opacity: 1;
  }
`;

export const FooterLinkDarkTheme = styled.a`
  color: inherit;
  font-size: 14px;
  text-decoration: none;
  opacity: 0.9;
  transition: color 160ms ease, opacity 160ms ease;

  &:hover {
    color: #9db7ff;
    opacity: 1;
  }
`;

export const PrivacyLink = styled.a`
  color: #8a2be2;
  font-size: 12px;
  text-decoration: none;
  opacity: 0.9;
  transition: color 160ms ease, opacity 160ms ease;

  &:hover {
    color: #4c6fff;
    opacity: 1;
  }
`;

export const MetaNote = styled.p`
  font-size: 12px;
  margin: 6px 0 0;
  opacity: 0.72;
  text-align: center;
`;

export const LegalRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  opacity: 0.82;
  justify-content: center;
`;
